<template>
  <div
    class="IndexContent"
    :style="[{'margin-top':top},{'margin-bottom':bottom}]"
  >
    <!-- 轮播 -->
    <div
      class="banner"
      v-cloak
    >
      <slider
        ref="slider"
        :options="options"
      >
        <!-- 直接使用slideritem slot -->
        <slideritem
          v-for="(item,index) in imgList"
          :key="index"
          :style="{'background-image': 'url('+item+')'}"
        ></slideritem>
        <!-- 设置loading,可自定义 -->
        <div slot="loading">loading...</div>
      </slider>
    </div>
    <!-- 中间的提示 -->
    <div class="ceasia-main">
      <div
        class="ceasia-main-h1"
        v-if="$i18n.locale=='zh'"
      >

      </div>
      <div
        class="ceasia-main-h2"
        :class="{'height':$i18n.locale=='en'}"
        v-for="(brand,index) in   lang"
        :key='index'
        :style="{fontSize:fontSize}"
      >
        {{brand}}
      </div>
      <div class="ceasia-main-botton">
        <router-link to="about">
          LEARN MORE
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'
export default {
  name: 'IndexContent',
  data() {
    return {
      imgList: [
        'https://s2.sonkwostatic.cn/ceasia_hk/images/index/7.png',
        'https://s2.sonkwostatic.cn/ceasia_hk/images/index/2.jpg',
        'https://s2.sonkwostatic.cn/ceasia_hk/images/index/3.jpg',
        'https://s2.sonkwostatic.cn/ceasia_hk/images/index/4.jpg',
        'https://s2.sonkwostatic.cn/ceasia_hk/images/index/5.jpg',
      ],
      currentIndex: 0, // 默认显示图片
      timer: null, // 定时器
      fontSize: '25px', // 字体的大小
      bottom: '0',
      top: '0',
      options: {
        currentPage: 0,
        thresholdDistance: 100,
        thresholdTime: 4000,
        autoplay: 4000,
        loop: true,
        direction: 'horizontal',
        loopedSlides: 1,
        slidesToScroll: 1,
        timingFunction: 'ease',
        speed: 4000,
        effect: 'fade',
      },
    }
  },
  components: {
    slider,
    slideritem,
  },
  methods: {
    gotoPage(index) {
      this.currentIndex = index
    },
  },
  // beforeUpdate () {
  //   let language = localStorage.getItem('locale');
  //   console.log(language);
  //   if (language === 'en') {
  //     this.fontSize = '25px';
  //     this.top = '200px';
  //     this.bottom = '300px';
  //   } else {
  //     this.fontSize = '40px';
  //     this.top = '0';
  //     this.bottom = '240px';
  //   }
  // },
  computed: {
    // 上一张
    prevIndex() {
      if (this.currentIndex === 0) {
        return this.imgList.length - 1
      } else {
        return this.currentIndex - 1
      }
    },
    // 下一张
    nextIndex() {
      if (this.currentIndex === this.imgList.length - 1) {
        return 0
      } else {
        return this.currentIndex + 1
      }
    },
    // 更新语言
    lang() {
      if (this.$t('IndexContent') !== 'IndexContent') {
        return this.$t('IndexContent')
      }
    },
  },
  created() {
    // 定时器
    this.timer = setInterval(() => {
      this.gotoPage(this.nextIndex)
    }, 4000)
    let language = this.$i18n.locale
    console.log(language)
    if (language === 'en') {
      this.fontSize = '25px'
      this.top = '200px'
      this.bottom = '175px'
      // line-height: 40px;
    } else {
      this.fontSize = '40px'
      this.top = '0'
      this.bottom = '240px'
    }
  },
  beforeCreate: function () {
    setTimeout(() => {
      if (grayscale() == 1) {
        document.getElementsByTagName('body')[0].classList.add('grayscale')
      }
    }, 1000)
  },
  beforeDestroy: function () {
    document.getElementsByTagName('body')[0].classList.remove('grayscale')
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
@import './style/index.css';
.en {
  font-size: 25px;
}
.height {
  line-height: 35px;
}
.banner {
  height: 1000px;
}
.slider-item {
  background-position: center;
}
[v-cloak] {
  display: none;
}
</style>
<style>
.grayscale {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/index/IndexContent.vue